import MenuBar from "../Component/MenuBar";
import PageBanner from '../Component/PageBanner';
import Sidebar from '../Component/Sidebar';
import Footer from "../Component/Footer";
import './EventDetail.css';

const SharadPoornima = () => {
    return (
        <>
            <MenuBar />
            <Sidebar />

            {/* Page Banner */}
            <PageBanner title="Sharad Poornima & Jagadguruttam Jayanti" />

            <div className="event-detail-container">
                <div className="event-detail-grid">
                    {/* Left Column - Event Info */}
                    <div className="event-info-column">
                        <div className="event-header">
                            <span className="event-category">Satsang & Celebrations</span>
                            <h1 className="event-title">Sharad Poornima & Jagadguruttam Jayanti</h1>
                            <p className="event-subtitle">Satsang & Celebrations Under the Full Moon</p>
                        </div>

                        {/* Quick Info Cards */}
                        <div className="event-quick-info">
                            <div className="info-card">
                                <i className="fa fa-calendar"></i>
                                <div>
                                    <span className="info-label">Date</span>
                                    <span className="info-value">Sunday, October 25, 2026</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-clock"></i>
                                <div>
                                    <span className="info-label">Time</span>
                                    <span className="info-value">6:00 PM - Midnight</span>
                                </div>
                            </div>
                            <div className="info-card">
                                <i className="fa fa-map-marker-alt"></i>
                                <div>
                                    <span className="info-label">Venue</span>
                                    <span className="info-value">Yugal Kunj, Duluth, GA</span>
                                </div>
                            </div>
                            <div className="info-card highlight">
                                <i className="fa fa-users"></i>
                                <div>
                                    <span className="info-label">Welcome</span>
                                    <span className="info-value">Everyone Is Welcome</span>
                                </div>
                            </div>
                        </div>

                        {/* Event Description */}
                        <div className="event-section">
                            <h3 className="section-title">About the Celebration</h3>
                            <p className="event-description">
                                Join us for Satsang and celebrations under the full moon at Yugal Kunj, 
                                honouring the appearance day of <strong>Jagadguru Shri Kripalu Ji Maharaj</strong>. 
                                An auspicious evening filled with kirtan, devotion and festivities until midnight.
                            </p>
                        </div>

                        {/* Event Highlights */}
                        <div className="event-section">
                            <h3 className="section-title">Event Highlights</h3>
                            <ul className="highlights-list">
                                <li><i className="fa fa-check-circle"></i>Sharad Poornima – Full Moon Celebration</li>
                                <li><i className="fa fa-check-circle"></i>Jagadguruttam Jayanti – Appearance Day of Jagadguru Shri Kripalu Ji Maharaj</li>
                                <li><i className="fa fa-check-circle"></i>Devotional Kirtan</li>
                                <li><i className="fa fa-check-circle"></i>Satsang Programs</li>
                                <li><i className="fa fa-check-circle"></i>Festivities Until Midnight</li>
                            </ul>
                        </div>

                        {/* Action Buttons */}
                        <div className="event-actions">
                            <a
                                href="https://maps.google.com/?q=2769+Duluth+Hwy,+Duluth,+GA+30096"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-primary"
                            >
                                <i className="fa fa-map-marker-alt"></i> Get Directions
                            </a>
                            <a
                                href="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/b5cab351_shard-purnima.jpeg"
                                target="_blank"
                                rel="noreferrer"
                                className="btn-secondary"
                            >
                                <i className="fa fa-download"></i> Download Flyer
                            </a>
                        </div>
                    </div>

                    {/* Right Column - Flyer */}
                    <div className="event-flyer-column">
                        <div className="flyer-wrapper">
                            <img
                                src="https://stssevastorage.blob.core.windows.net/media/yugalkunj/events/image/1/b5cab351_shard-purnima.jpeg"
                                alt="Sharad Poornima & Jagadguruttam Jayanti"
                                className="event-flyer-image"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default SharadPoornima;
